'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HotelSearchBox = exports.mapDispatchToProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.mapStateToProps = mapStateToProps;
exports.submit = submit;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRouterRedux = require('react-router-redux');

var _reactRedux = require('react-redux');

var _trvFedUtil = require('../trv-fed-util');

var _filters = require('../helpers/filters');

var _query = require('../helpers/query');

var _search = require('../modules/search');

var _hotels = require('../modules/hotels');

var _filters2 = require('../modules/filters');

var _exception = require('../modules/exception');

var _searchBox = require('../modules/searchBox');

var _destinationParser = require('../helpers/destination-parser');

var _SearchBox = require('../components/SearchBox');

var _SearchBox2 = _interopRequireDefault(_SearchBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// mapStateToprops can be either an object or a funciton


// api

// if bindActionCreators is needed, uncomment this line
// import {bindActionCreators} from 'redux';
function mapStateToProps(state, ownProps) {
  var values = (0, _query.convertSearchStateToForm)(state.search);
  var breadcrumbs = _lodash2.default.cloneDeep(state.breadcrumbs.items);
  var destination = void 0;
  if (__SERVER__) {
    breadcrumbs.reverse().pop();
    destination = breadcrumbs.length > 1 ? breadcrumbs.map(function (breadcrumb) {
      return breadcrumb.text;
    }).join(', ') : '';
  } else {
    destination = (0, _destinationParser.getSearchText)(window.list, state.search);
  }

  return {
    isLoading: state.hotels.isLoading,
    i18n: state.i18n,
    urls: state.urls,
    search: state.search,
    filters: state.filters.filters,
    priceRange: state.filters.priceRange,
    req: state.httpRequest.req,
    searchErrors: state.search.errors,
    values: values,
    destination: destination,
    display: ownProps.display || state.searchBox.display
  };
}

// mapDispatchToprops can be either an object or a funciton


// components
var mapDispatchToProps = exports.mapDispatchToProps = {
  push: _reactRouterRedux.push,
  setHotels: _hotels.set,
  setSearch: _search.set,
  setFilters: _filters2.setFilters,
  setPriceRange: _filters2.setPriceRange,
  setSearchErrors: _search.setErrors,
  clearSearchErrors: _search.clearErrors,
  fetchHotelsBegin: _hotels.fetchBegin,
  clearHotels: _hotels.clear,
  throwException: _exception.throwException,
  clearException: _exception.clearException,
  setSearchBoxDisplay: _searchBox.set
};

function submit(values, props) {
  var search = props.search,
      push = props.push,
      urls = props.urls,
      filters = props.filters,
      priceRange = props.priceRange,
      fetchHotelsBegin = props.fetchHotelsBegin,
      setSearchBoxDisplay = props.setSearchBoxDisplay;


  var params = (0, _extends3.default)({}, search, (0, _filters.convertToParams)({ filters: filters, priceRange: priceRange }), (0, _query.convertFormToSearchState)(values), {
    offset: '0'
  });
  setSearchBoxDisplay(params.stay.match(/\[\d+-\d+-\d+,\d+-\d+-\d+\]/) ? 'text' : 'form');
  fetchHotelsBegin();
  push({
    pathname: (0, _trvFedUtil.normalize)(urls.app.hotellist, { areaID: values.destination }),
    query: (0, _query.convertStateToLocationQuery)({ search: params })
  });
}

var HotelSearchBox = exports.HotelSearchBox = function (_Component) {
  (0, _inherits3.default)(HotelSearchBox, _Component);

  function HotelSearchBox() {
    (0, _classCallCheck3.default)(this, HotelSearchBox);
    return (0, _possibleConstructorReturn3.default)(this, (HotelSearchBox.__proto__ || (0, _getPrototypeOf2.default)(HotelSearchBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(HotelSearchBox, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var shouldDisplayText = this.props.search.stay.match(/\[\d+-\d+-\d+,\d+-\d+-\d+\]/);
      this.props.setSearchBoxDisplay(shouldDisplayText ? 'text' : 'form');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isLoading = _props.isLoading,
          i18n = _props.i18n,
          search = _props.search,
          push = _props.push,
          urls = _props.urls,
          req = _props.req,
          values = _props.values,
          destination = _props.destination,
          setSearch = _props.setSearch,
          filters = _props.filters,
          priceRange = _props.priceRange,
          display = _props.display,
          hideDetails = _props.hideDetails,
          setSearchErrors = _props.setSearchErrors,
          clearSearchErrors = _props.clearSearchErrors,
          searchErrors = _props.searchErrors,
          fetchHotelsBegin = _props.fetchHotelsBegin,
          setSearchBoxDisplay = _props.setSearchBoxDisplay;

      return _react2.default.createElement(_SearchBox2.default, {
        display: display,
        hideDetails: hideDetails,
        hasDestination: true,
        destination: destination,
        i18n: i18n,
        lang: i18n.lang,
        submitText: i18n.searchForm.search,
        errors: searchErrors.filter(function (error) {
          return error.fields === 'destination' || error.fields === 'checkin' || error.fields === 'checkout';
        }),
        values: values,
        isMobile: req.useragent.isMobile,
        isLoading: isLoading,
        onChange: function onChange(values) {
          var params = (0, _extends3.default)({}, search, (0, _filters.convertToParams)({ filters: filters, priceRange: priceRange }), (0, _query.convertFormToSearchState)(values));
          setSearch(params);
        },
        onSubmit: function onSubmit(values) {
          submit(values, {
            search: search,
            push: push,
            urls: urls,
            filters: filters,
            priceRange: priceRange,
            fetchHotelsBegin: fetchHotelsBegin,
            setSearchBoxDisplay: setSearchBoxDisplay
          });
        },
        setSearchErrors: setSearchErrors,
        clearSearchErrors: clearSearchErrors,
        setSearchBoxDisplay: setSearchBoxDisplay
      });
    }
  }]);
  return HotelSearchBox;
}(_react.Component);

HotelSearchBox.propTypes = {
  isLoading: _react.PropTypes.bool,
  i18n: _react.PropTypes.object.isRequired,
  search: _react.PropTypes.object,
  values: _react.PropTypes.object,
  urls: _react.PropTypes.object.isRequired,
  push: _react.PropTypes.func.isRequired,
  req: _react.PropTypes.object,
  destination: _react.PropTypes.string,
  setSearch: _react.PropTypes.func.isRequired,
  fetchHotelsBegin: _react.PropTypes.func.isRequired,
  filters: _react.PropTypes.array.isRequired,
  priceRange: _react.PropTypes.object.isRequired,
  display: _react.PropTypes.oneOf(['text', 'form']),
  hideDetails: _react.PropTypes.bool,
  searchErrors: _react.PropTypes.array.isRequired,
  setSearchErrors: _react.PropTypes.func.isRequired,
  clearSearchErrors: _react.PropTypes.func.isRequired,
  setSearchBoxDisplay: _react.PropTypes.func.isRequired
};

HotelSearchBox.defaultProps = {
  hideDetails: false
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HotelSearchBox);


//////////////////
// WEBPACK FOOTER
// ./src/containers/HotelSearchBox.js
// module id = 187
// module chunks = 0